export default {
  name: 'monthResult'
}
